class AddInputController {
  constructor() {
    this.name = 'addInput';
  }
}

export default AddInputController;
